module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "child bounce1",
    style: ({
      backgroundColor: _vm.color ? _vm.color : '#B0C3D5'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "child bounce2",
    style: ({
      backgroundColor: _vm.color ? _vm.color : '#B0C3D5'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "child bounce3",
    style: ({
      backgroundColor: _vm.color ? _vm.color : '#B0C3D5'
    })
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26f03a58","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/partials/loading-indicator.vue
// module id = 514
// module chunks = 0